// extracted by mini-css-extract-plugin
export var inputContainer = "_ps-0";